// extracted by mini-css-extract-plugin
export var button = "_le-0";
export var donut = "_le-1";
export var donutFill = "_le-3";
export var donutTrack = "_le-2";